import React from "react";

import { ModalWithChildrenContainer } from "./modal-with-children-style";
import { images } from "../../assets/images";
import H4Text from "../components-text/h4-text";

const ModalWithChildren = ({
  children,
  active,
  mainTitle,
  width,
  maxWidth,
  img,
  close,
}: {
  children: React.ReactChild;
  active?: boolean;
  mainTitle?: string;
  width?: string;
  maxWidth?: string;
  img?: string;
  close?: () => void;
}) => {
  return (
    <ModalWithChildrenContainer className={`${active ? "active" : ""}`} width={width} maxWidth={maxWidth}>
      <div className="modal-content-wrapper">
        {close && (
          <div className="modal-close">
            <img src={images.IconCloseGrey} onClick={() => close()} alt="icono cierre" />
          </div>
        )}
        <div className="modal">
          {mainTitle && (
            <div className="modal-title">
              <div className="modal-icon-bg">
                <img src={img} alt="icono" />
              </div>

              <div className="modal-text">
                <H4Text>{mainTitle}</H4Text>
              </div>
            </div>
          )}
          {children}
        </div>
      </div>
    </ModalWithChildrenContainer>
  );
};

export default ModalWithChildren;
